module.exports = __webpack_public_path__ + "src/assets/img/lock.88f49c1c.svg";